module.exports = __webpack_public_path__ + "img/33-dec.4fa80693.png";